import { render, staticRenderFns } from "./exhibition-release.vue?vue&type=template&id=1628f174&scoped=true&"
import script from "./exhibition-release.vue?vue&type=script&lang=js&"
export * from "./exhibition-release.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-release.vue?vue&type=style&index=0&id=1628f174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1628f174",
  null
  
)

export default component.exports